module.exports = __webpack_public_path__ + "img/step21_a_printer_basic_open_roll_cover_remove_tapes.0b8d6146.png";